export enum CMSType {
    ABANDONED_CART = 'ABANDONED_CART',
    RECOMMENDER = 'RECOMMENDER',
    ABANDONED_ITEM = 'ABANDONED_ITEM',
    CUSTOMER_RECOMMENDER = 'CUSTOMER_RECOMMENDER',
    ABANDONED_WISHLIST = 'ABANDONED_WISHLIST',
}

export const CMSDisplayNames: {
    [key in CMSType]: string;
} = {
    [CMSType.ABANDONED_CART]: 'Cart abandonment',
    [CMSType.ABANDONED_ITEM]: 'Browse abandonment',
    [CMSType.RECOMMENDER]: 'Recommender',
    [CMSType.CUSTOMER_RECOMMENDER]: 'Customer recommender',
    [CMSType.ABANDONED_WISHLIST]: 'Wishlist abandonment',
};

export enum CMSFilterType {
    GENERAL = 'All',
    SPECIFIC = 'Specific',
}

export enum CMSOperators {
    Equals = 'equals',
    NotEquals = 'not_equals',
    GreaterThan = 'greater_than',
    LessThan = 'less_than',
    GreaterThanEquals = 'greater_than_equals',
    LessThanEquals = 'less_than_equals',
}

export enum CMSInputType {
    Integer = 'int',
    String = 'str',
    Float = 'float',
    Boolean = 'bool',
}

export const CMSInputOperators: Record<CMSInputType, CMSOperators[]> = {
    [CMSInputType.Boolean]: [CMSOperators.Equals, CMSOperators.NotEquals],
    [CMSInputType.Integer]: [
        CMSOperators.Equals,
        CMSOperators.NotEquals,
        CMSOperators.GreaterThan,
        CMSOperators.LessThan,
        CMSOperators.GreaterThanEquals,
        CMSOperators.LessThanEquals,
    ],
    [CMSInputType.String]: [CMSOperators.Equals, CMSOperators.NotEquals],
    [CMSInputType.Float]: [
        CMSOperators.Equals,
        CMSOperators.NotEquals,
        CMSOperators.GreaterThan,
        CMSOperators.LessThan,
        CMSOperators.GreaterThanEquals,
        CMSOperators.LessThanEquals,
    ],
};

export interface CMSPlaceholderModel {
    id: string;
    name: string;
    type: CMSType;
    sample_value?: string;
    is_filterable?: boolean;
    is_messageable?: boolean;
    values?: string[];
    input_type?: CMSInputType;
}

export interface CMSFilterCreateModel {
    cms_placeholder_id: string;
    operator: CMSOperators;
    value: string;
}

export interface CMSFilterModel extends CMSFilterCreateModel {
    id: string;
}

export interface CartFilterFormValues {
    cms_filters?: CMSFilterCreateModel[];
    cms_filter_type: CMSFilterType;
    cms_type?: { label: string; value: string };
}

export const DEFAULT_CMS_TYPE_VALUE = 'none';

export const DEFAULT_CMS_TYPE_OPTION = {
    value: DEFAULT_CMS_TYPE_VALUE,
    label: 'None',
};
